import React from "react";
import { Outlet } from "react-router-dom";
import ProfileSidebar from "./ProfileSidebar";

const ProfileSection: React.FC = () => {
  return (
    <div className="box flex h-full flex-col gap-4 lg:flex-row">
      <ProfileSidebar /> 
      <div className="border m-2 lg:h-full"/>
      <Outlet />
    </div>
  );
};

export default ProfileSection;
